import { useState, useEffect, useMemo } from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input, Form, FormGroup, Spinner } from 'reactstrap';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import './Outline.css';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import MapView from '../Map/MapView';
import OutlineNonMap from './OutlineNonMap';
import OutlineMapView from './OutlineMapView';
import Geocode from "react-geocode";
import StaticMapView from '../Map/StaticMapView';

const Outline = ({ handleWizardChanged, handleMoveToNextPage, handleWizardChangedBack }) => {
    const roleName = localStorage.getItem("roleName");
    const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [reportButtonVisible, setReportButtonVisible] = useState(false);
    const [saving, setSaving] = useState('');
    const [toggleSwitch, setToggleSwitch] = useState('map & details');
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [savingItem, setSavingItem] = useState('');
    const [savingItemDelete, setSavingItemDelete] = useState('');
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [itemName, setItemName] = useState('');
    const [generateReport, setGenerateReport] = useState(false);
    const [isWholeFarmOutline, setIsWholeFarmOutline] = useState(false);
    const [isLargeEnterprise, setIsLargeEnterprise] = useState(false);
    const [outline, setOutline] = useState({ outlineList: [], itemList: [], itemTypes: [], zoomLevelList: [], Section: 'Outline', SectionName: 'Outline', isWizardCompleted: false, farmAddress : '' });
    const [loading, setLoading] = useState(true);
    const [typeid, setTypeId] = useState(0);
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: true, isLMUPage: false, isCenterReq: true, itemsEditable: false,
        isFarmCenterEditable: false, isFarmOutlineEditable: false, zoomLevel: 5, polyType: '', highlighteditemId: 0, isFindmyFarm: false, myFarmCenter: '', isClear: false
    });
    const [kmlUpload, setkmlUpload] = useState({ isUpload: false, uploadedShape: [], AreaList: [], PerimeterList: [] });
    const [itemPopup, setItemPopup] = useState({
        showItemPopup: false, mapitem: [], farmId: farmId, id: 0, itemId: '',
        markertype: "", area: 0.0, perimeter: 0.0, name: '',
        coordinates: '', isDragged: false, isEdited: false
    });
    const [itemDeletePopup, setItemDeletePopup] = useState({ showItemdeletePopup: false, itemId: 0 });
    const [itemBulkPopup, setItemBulkPopup] = useState({ showBulkItemPopup: false, uploadedShape: [], AreaList: [], PerimeterList: [] });

 
    const getBase64Image = async (img) => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png");
        return dataURL;
    }

    const base64ToArrayBuffer = (data) => {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    const generateFarmMapReport = async (e) => {
        var FarmMapImage = await getBase64Image(document.getElementById('FarmMapImage'));
        let form = {
            FarmMapImage: FarmMapImage,
            FarmId: farmId
        }

        const response = await axios.post(
            '/api/outline/ExportFarmMapReport/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });

        if (response.data.status) {
            setGenerateReport(false);
            setReportButtonVisible(false);
            toast.success("Report generated!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/pdf" })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "Farm Map.pdf";
            document.body.appendChild(link)
            link.click();
        }
        else {
            setGenerateReport(false);
            setReportButtonVisible(false);
            toast.error("Error when generating report", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        return response;
    }

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const OnPageload = async (e) => {
        try {
            const response = await axios.get(
                '/api/outline/GetOutline/', {
                params: {
                    farmId: farmId
                }
            }
            );
            setOutline({ ...outline, outlineList: response.data.outlineList, itemTypes: response.data.itemTypes, zoomLevelList: response.data.zoomLevelList, isWizardCompleted: response.data.isFWFPCompleted, farmAddress: response.data.farmAddress });

            setIsLargeEnterprise(response.data.islargeEnterprise);
            if (response.data.outlineList.length == 0 && (response.data.farmAddress != null || response.data.farmAddress != "")) {
                findMyFarmOnpageLoad(response.data.farmAddress);
            }
            else {
                setMapDetails({ ...mapDetails, zoomLevel: response.data.selectedZoomlevel, isUndoReq: false, isUndoClick: false });
            }
            if (response.data.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName == response.data.section.routePath);
                if (section.length > 0 != null) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }
            setGenerateReport(false);
            setReportButtonVisible(false);
            setLoading(false);
        } catch (err) {
            console.log(err);
        }
    }

    /*Item Selection */
    const handleItemClick = (event, typeid, polyType) => {

        const outlineList = outline.outlineList;
        const OutlineTypeLength = outlineList.filter(type => type.mapType == 'marker').length;
        if (OutlineTypeLength > 0 && polyType == 'marker') {
            toast.success("Already have one Farm Center", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            handleClearSelection1()
        }
        else {
            setTypeId(typeid);
            setMapDetails({ ...mapDetails, polyType: polyType, isClear: false });
        }
    };

    const handleClearSelection = () => {
        setTypeId(0);
        setMapDetails({ ...mapDetails, polyType: '', isClear: true });
        window.location.reload(true);
    }
    const handleClearSelection1 = () => {
        setTypeId(0);
        setMapDetails({ ...mapDetails, polyType: '', isClear: true });
    }
    /* KML Upload*/
    //const onFileChange = async (event) => {
    //    if (event.target.files[0] != undefined) {
    //        const formData = new FormData();
    //        formData.append("fileName", event.target.files[0].name);
    //        formData.append("File", event.target.files[0]);
    //        try {
    //            const response = await axios.post(
    //                '/api/outline/UploadKMLFiles/', formData,
    //                {
    //                    headers: { 'Content-Type': 'application/json' },
    //                    withCredentials: true
    //                });
    //            handleUploadSave(response.data);

    //        } catch (error) {
    //            console.error('Error:', error);
    //        }
    //    }
    //};

    //const handleUploadSave = (uploadedShape) => {
    //    if (uploadedShape != null) {
    //        let areaList = [];
    //        let perimeterList = [];
    //        uploadedShape.map((OutlineItem) => {
    //            const Coordinates = OutlineItem.coordinates.split(':');
    //            const positions = [];

    //            Coordinates.filter(coor => coor != "").map((Coordinate) => {
    //                const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
    //                positions.push(pos);
    //            })

    //            const tempPolygon = new window.google.maps.Polygon({
    //                paths: positions
    //            });

    //            let path = tempPolygon.getPath();
    //            let area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
    //            let perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
    //            areaList.push(area);
    //            perimeterList.push(perimeter);
    //        })
    //        setkmlUpload({ isUpload: true, uploadedShape: uploadedShape })

    //        setItemBulkPopup({ farmId: farmId, showBulkItemPopup: true, uploadedShape: uploadedShape, AreaList: areaList, PerimeterList: perimeterList })
    //    }
    //}

    //const uploadkmlShapeClick = () => {
    //    document.getElementById('uploadKML').click();
    //}

    const importShapeFilesClick = () => {
        window.open('shapeUpload', "_self");
    }

    const HandleBulkItemPopupClose = () => {
        setItemBulkPopup({ farmId: farmId, showBulkItemPopup: false, uploadedShape: [], AreaList: [], PerimeterList: [] });
        setkmlUpload({ isUpload: false, uploadedShape: [] });
    }

    const handleBulkItemSubmit = async (event) => {

        const item = itemBulkPopup;

        let form = {
            farmId: item.farmId,
            Name: itemName,
            outlineList: item.uploadedShape,
            AreaList: item.AreaList,
            PerimeterList: item.PerimeterList,
            userId: userId
        }
        try {
            const response = await axios.post(
                '/api/outline/UpdateBulkOutline/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            HandleBulkItemPopupClose();
            window.location.reload(true);
        } catch (error) {
            console.error('Error:', error);
        }
    }

    /*Value Change */
    const handleNameChange = (event) => {
        const { name, value, checked, type } = event.target;
        if (name == 'txtShapeName') {
            if (event.target.value.length > 60) {
                return false;
            }
        }
        setItemName(event.target.value);
    }

    const handleZoomChange = (event) => {
        setMapDetails({ ...mapDetails, zoomLevel: parseInt(event.target.value) });
    }

    const handlelargeEnterpriseChange = (event) => {
        setIsLargeEnterprise(event.target.checked);
    }

    const handleIsWholeFarmOutlineChange = (event) => {
        setIsWholeFarmOutline(event.target.checked);
    }

    const handleZoomLevel = (zoomLevel) => {
        setMapDetails({ ...mapDetails, zoomLevel: zoomLevel });
    }
 
    /*Item Save and Edit*/
    const addMapItem = (mapItem, maptype) => {
        let name, path, area = 0.0, perimeter = 0.0, coordinates = '';

        if (maptype == 'marker') {
            name = "Map Centre";
            setItemName(name);
            coordinates = mapItem.getPosition().lat().toFixed(6) + ", " + mapItem.getPosition().lng().toFixed(6);

        }
        else if (maptype == 'polygon') {
            path = mapItem.getPath();
            setItemName('');
            setIsWholeFarmOutline(false);
            area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            var PolygonCoords = "";
            path.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            coordinates = PolygonCoords;
        }

        setItemPopup({
            showItemPopup: true, mapitem: mapItem, farmId: farmId, id: 0,
            itemId: typeid, markertype: maptype, area: area,
            perimeter: perimeter, name: name, coordinates: coordinates, isDragged: false, isEdited: false
        });

    }

    const editMapItem = (mapItem, itemId, isDragged) => {
        let id = 0, name, area = 0.0, perimeter = 0.0, coordinates = '', maptype = '', isEdited = false;

        const outlineList = outline.outlineList;
        let selectedItem = outlineList.filter(item => item.itemId == itemId)[0];

        if (selectedItem != null) {

            if (isDragged && selectedItem.mapType == 'marker') {
                coordinates = mapItem.latLng.lat().toFixed(6) + ", " + mapItem.latLng.lng().toFixed(6);
                area = selectedItem.area;
                perimeter = selectedItem.perimeter;
            }
            else if (selectedItem.isEdited && selectedItem.mapType == 'polygon')
            {
                coordinates = selectedItem.coordinates;
                const Coordinates = coordinates.split(':');
                const positions = [];
                Coordinates.filter(coor => coor != "").map((Coordinate) => {
                    const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                    positions.push(pos);
                })
                const tempPolygon = new window.google.maps.Polygon({
                    paths: positions
                });

                let path = tempPolygon.getPath();
                area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
                perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            }
            else {
                area = selectedItem.area;
                perimeter = selectedItem.perimeter;
                coordinates = selectedItem.coordinates;
            }

            name = selectedItem.name;
            area = area;
            perimeter = perimeter;
            isEdited = selectedItem.isEdited;
            maptype = selectedItem.mapType;
            id = selectedItem.id;
            setItemName(name);
            setIsWholeFarmOutline(selectedItem.isFarmOutline == true ?true : false);
            setItemPopup({
                showItemPopup: true, farmId: farmId, id: id,
                itemId: itemId, markertype: maptype, area: area,
                perimeter: perimeter, name: name,
                coordinates: coordinates, isDragged: isDragged, isEdited: isEdited
            });
        }
    }

    const handleItemPopupClose = () => {
        setItemPopup({
            showItemPopup: false, mapitem: [],
            farmId: farmId, id: 0, itemId: '',
            markertype: '', area: 0.0, perimeter: 0.0, name: '',
            coordinates: '', isDragged: false, isEdited: false
        });
        setMapDetails({ ...mapDetails, isClear: true });
    }

    const handleItemSubmit = async (event) => {
        setSavingItem(true);
        const item = itemPopup;

        let form = {
            Id: item.id,
            Maptype: item.markertype,
            ItemId: item.itemId,
            Name: itemName,
            Area: item.area,
            Perimeter: item.perimeter,
            Coordinates: item.coordinates,
            FarmId: item.farmId,
            isDragged: item.isDragged,
            isEdited: item.isEdited,
            userId: userId,
            IsFarmOutline: isWholeFarmOutline
        }
        try {
            const response = await axios.post(
                '/api/outline/UpdateOutline/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.data != null) {
                const response = await axios.get(
                    '/api/outline/GetOutline/', {
                    params: {
                        farmId: farmId
                    }
                }
                );
                setOutline({ ...outline, outlineList: response.data.outlineList });
                setTypeId(0);
                setMapDetails({ ...mapDetails, polyType: '', isClear: true });
                setSavingItem(false);
                setItemPopup({
                    showItemPopup: false, mapitem: [],
                    farmId: farmId, id: 0, itemId: '',
                    markertype: '', area: 0.0, perimeter: 0.0, name: '',
                    coordinates: '', isDragged: false, isEdited: false
                });
                setReportButtonVisible(false)
                setGenerateReport(false)
            }            
        } catch (error) {
            setSavingItem(false);
            console.error('Error:', error);
        }
    }

    const handleMapItemEdited = (itemId, type, strValue) => {
        let name = '';
        let value = '';
        if (type == "polygonBoundsChanged") {
            name = 'coordinates';
            var PolygonCoords = "";
            strValue.getArray().map((pointCo) => {
                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            value = PolygonCoords;
        }

        const itemList = outline.outlineList.map(item =>
            item.itemId === itemId
                ? { ...item, [name]: value, isEdited: true }
                : item
        )
        setOutline({ ...outline, outlineList: itemList });
    }

     /*Item Delete*/
    const handleItemDelete = () => {
        setItemDeletePopup({ showItemdeletePopup: true, itemId: itemPopup.itemId });
    }

    const HandleItemDeletePopupClose = () => {
        setItemDeletePopup({ showItemdeletePopup: false, itemId: 0 });
    }

    const deleteItem = async (event) => {
        setSavingItemDelete(true);
        const itemid = itemDeletePopup.itemId;
        try {
            const response = await axios.get(
                '/api/outline/DeleteOutline/', {
                params: {
                    itemId: itemid,
                    userId: userId
                }
            }
            );
            if (response.data != null) {
                const response = await axios.get(
                    '/api/outline/GetOutline/', {
                    params: {
                        farmId: farmId
                    }
                }
                );
                setOutline({ ...outline, outlineList: response.data.outlineList });
                setItemDeletePopup({ showItemdeletePopup: false, itemId: 0 });
                setItemPopup({
                    showItemPopup: false, mapitem: [],
                    farmId: farmId, id: 0, itemId: '',
                    markertype: '', area: 0.0, perimeter: 0.0, name: '',
                    coordinates: '', isDragged: false, isEdited: false
                });
                setSavingItemDelete(false);
                setGenerateReport(false);
            }       
        } catch (error) {
            setSavingItemDelete(false);
            console.error('Error:', error);
        }
    }

    /*Farm Details Save*/
    const handleFarmDetailSave = async (e) => {
        e.preventDefault()
        setSaving(true);

        try {
            let form = {
                farmId: farmId,
                IslargeEnterprise: isLargeEnterprise,
                selectedZoomlevel: mapDetails.zoomLevel,
                userId: userId
            }
            try {
                const response = await axios.post(
                    '/api/outline/UpdateOutlineFarmDetails/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    });
            } catch (error) {
                console.error('Error:', error);
            }

            setTimeout(() => {
                setSaving(false);
            }, 1000)

            toast.success("My Farm Details Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });

        } catch (err) {
            setTimeout(() => {
                setSaving(false);
            }, 1000)

            if (!err?.response) {
                toast.error("No server response!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else if (err.response?.status === 400) {
                toast.error("My Farm Details Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("My Farm Details Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }

    const handleWizardChangedOutline = async (e) => {
        e.preventDefault()
        try {
            let form = {
                farmId: farmId,
                IslargeEnterprise: isLargeEnterprise,
                selectedZoomlevel: mapDetails.zoomLevel,
                userId: userId
            }
            try {
                const response = await axios.post(
                    '/api/outline/UpdateOutlineFarmDetails/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    });
                if (response != null) {
                    handleWizardChanged(outline.Section);
                }
            } catch (error) {
                console.error('Error:', error);
            }

            setTimeout(() => {
            }, 1000)

            toast.success("My Farm Details Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });

        } catch (err) {
            if (!err?.response) {
                toast.error("No server response!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else if (err.response?.status === 400) {
                toast.error("My Farm Details Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("My Farm Details Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }

    const hasOutlineCentre = (outlineList) => {
        let farmCenter = false, farmBoundary = false;
        const FarmCenterList = outlineList.filter(type => type.mapType == 'marker');
        var FarmBoundaryList = outlineList.filter(type => type.mapType == 'polygon');
        if (FarmCenterList != null && FarmCenterList.length > 0) {
            farmCenter = true;
        }
        if (FarmBoundaryList != null && FarmBoundaryList.length > 0) {
            farmBoundary = true;
        }
        return (farmCenter && farmBoundary);
    }

    const noFarmCentreError = () => {
        const FarmCenterList = outline.outlineList.filter(type => type.mapType == 'marker');
        var farmBoundary = outline.outlineList.filter(type => type.mapType == 'polygon');
        var haveFarmBoundary = farmBoundary.length > 0 ? true : false;
        var haveFarmCenter = FarmCenterList.length > 0 ? true : false;
        if (!haveFarmBoundary && !haveFarmCenter) {
            toast.error("Please add a property Centre and minimum one boundary to move forward ...", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        else if (!haveFarmCenter) {
            toast.error("Please add a Property Centre to move forward ...", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        else if (!haveFarmBoundary) {
            toast.error("Please add minimum one boundary to move forward ...", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
    }

    /*handle Item highlight*/
    const handleItemHighlight = (itemId) => {
        setMapDetails({ ...mapDetails, highlighteditemId: itemId })
    }

    /*handle edit from Non map side*/
    const handleItemPopup = (itemId) => {
        editMapItem([], itemId,false);
    }

    /*handle delete from Non map side*/
    const handleItemDeletePopup = (itemId) => {
        setItemDeletePopup({ showItemdeletePopup: true, itemId: itemId });
    }

    const findMyFarm = () =>
    {
        Geocode.setApiKey("AIzaSyBYN1ILqaOOYkmN8-rk3T0ImqfQGY07Nfw");
        Geocode.setLanguage("en");
        Geocode.setRegion("nz");
        Geocode.fromAddress(outline.farmAddress).then(
            (response) => {
                const farmlocation = response.results[0].geometry.location;
                console.log(farmlocation);
                setMapDetails({ ...mapDetails, isFindmyFarm: true, zoomLevel: 15, myFarmCenter: farmlocation })
            },
            (error) => {
                toast.error("Invalid address. Please enter a valid Address in Farm settings", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        );
    }

    const findMyFarmOnpageLoad = (propertyAddress) => {
        Geocode.setApiKey("AIzaSyBYN1ILqaOOYkmN8-rk3T0ImqfQGY07Nfw");
        Geocode.setLanguage("en");
        Geocode.setRegion("nz");
        Geocode.fromAddress(propertyAddress).then(
            (response) => {
                const farmlocation = response.results[0].geometry.location;
                setMapDetails({ ...mapDetails, isFindmyFarm: true, zoomLevel: 15, myFarmCenter: farmlocation, isUndoReq: false, isUndoClick: false })
            },
            (error) => {
                toast.error("Invalid address. Please enter a valid Address in Property settings", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        );
    }

    const nonMapView = useMemo(() => {
        return (
            <OutlineNonMap outline={outline} mapDetails={mapDetails} saving={saving} isLargeEnterprise={isLargeEnterprise}
                handleClearSelection={handleClearSelection} handleItemClick={handleItemClick}
                handlelargeEnterpriseChange={handlelargeEnterpriseChange}
                handleZoomChange={handleZoomChange} handleFarmDetailSave={handleFarmDetailSave}
                importShapeFilesClick={importShapeFilesClick}
                handleItemHighlight={handleItemHighlight}
                handleItemPopup={handleItemPopup}
                handleItemDeletePopup={handleItemDeletePopup}
                findMyFarm={findMyFarm}/>
        )
    }, [outline, saving, isLargeEnterprise, mapDetails])

    const itemTypeListView = useMemo(() => {
        return (
            <OutlineMapView outline={outline} mapDetails={mapDetails} saving={saving} isLargeEnterprise={isLargeEnterprise}
                handleClearSelection={handleClearSelection} handleItemClick={handleItemClick}
                handlelargeEnterpriseChange={handlelargeEnterpriseChange}
                handleZoomChange={handleZoomChange} handleFarmDetailSave={handleFarmDetailSave}
                importShapeFilesClick={importShapeFilesClick}
                findMyFarm={findMyFarm} />
        )
    }, [outline, saving, isLargeEnterprise, mapDetails])

    const toggleSwitchChange = (value) => {
        setToggleSwitch(value)
        if (value == 'map') {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'none';
            document.getElementById('itemTypeListView').style.height = '70vh';
        }
        else if (value == 'details') {
            document.getElementById('mapView').style.display = 'none';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
        else {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
    }

    const handleEditItemClick = (e) => {
        if (e.target.checked) {
            toast.error("ALERT: when editing a shape remember to click inside the shape when finished, or when editing a line double click on the line, to save any changes.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        setMapDetails({ ...mapDetails, isFarmCenterEditable: !mapDetails.itemsEditable, isFarmOutlineEditable: !mapDetails.itemsEditable, itemsEditable: !mapDetails.itemsEditable })
    }

    const generateReportOutline = async (e) => {
        setGenerateReport(true);
        toast.loading("Generating report...", { duration: 4500, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE' } });
    }

    const generateReportafterDelay = async (e) => {

        setTimeout(() => {
            generateFarmMapReport();
        }, 3000)
    }

    const mapView = useMemo(() => {
        return (
            <MapView itemModel={outline} mapDetails={mapDetails} kmlUpload={kmlUpload} width={toggleSwitch == 'map' ? '75vw' : '50vw'}
                height={toggleSwitch == 'map' ? '75vw' : '50vw'}
                addMapItem={addMapItem}
                editMapItem={editMapItem}
                handleMapItemEdited={handleMapItemEdited}
                handleZoomLevel={handleZoomLevel}>
            </MapView>
        )
    }, [outline, mapDetails, kmlUpload, toggleSwitch])

    const staticOutlinemapView = useMemo(() => {
        return (
            <StaticMapView itemModel={outline} mapDetails={mapDetails} farmCentreReq={true} id="FarmMapImage" setReportButtonVisible={setReportButtonVisible} reportButtonVisible={reportButtonVisible}  />
        )
    }, [outline, mapDetails])


    return (

        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{outline.SectionName}</h3></Col>
                { (roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') && !loading &&
                    <Col> {hasOutlineCentre(outline.outlineList) == true ?
                        <Button className="btn-next-page float-end" onClick={(e) => handleWizardChangedOutline(e)}>Next <FaChevronRight /> </Button> :
                        <Button className="float-end btn-next-page-warning" onClick={noFarmCentreError}>Next <FaChevronRight /> </Button>}
                        <Button className="float-end btn-next-page" onClick={handleFarmDetailSave}>Save  </Button>
                        <Button className="float-end btn-next-page" onClick={(section) => handleWizardChangedBack(outline.Section)}>Back <FaChevronLeft /> </Button>
                    </Col>
                }
                { (roleName != 'Admin' && saveRightsForNonItemFieldsAndTables == 'false') && isNextButtonVisible && !loading &&
                    <Col> {hasOutlineCentre(outline.outlineList) == true ?
                        <Button className="btn-next-page float-end" onClick={(e) => handleMoveToNextPage(outline.Section)}>Next <FaChevronRight /> </Button> :
                        <Button className="float-end btn-next-page-warning" onClick={noFarmCentreError}>Next <FaChevronRight /> </Button>}
                        <Button className="float-end btn-next-page" onClick={handleFarmDetailSave}>Save  </Button>
                        <Button className="float-end btn-next-page" onClick={(section) => handleWizardChangedBack(outline.Section)}>Back <FaChevronLeft /> </Button>
                    </Col>
                }
                
            </Row>
            <br/>
            {loading ? <SpinnerContainer /> :
                <div>
                    <Row style={{ marginTop: '10px' }}>
                        <Col id='mapView'>
                            <Row className="map-layer">
                                <Col>
                                    <Row>
                                        <Col sm="3"> {toggleSwitch == 'map & details' &&
                                            <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map')}>Full Map&nbsp;&nbsp;
                                                <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                            {toggleSwitch == 'map' &&
                                                <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Map&nbsp;&nbsp;
                                                    <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                                </Button>
                                            }
                                        </Col>
                                        <Col sm="1"></Col>
                                        <Col sm="8">
                                            <div className="map-item-edit-div">
                                                <Label className="map-checkbox-label">Edit Item</Label>
                                                <Input className="map-item-edit-checkbox" type="checkbox" checked={mapDetails.itemsEditable} onChange={(e) => handleEditItemClick(e)} name="isItemEdit" id="isItemEdit" />
                                                
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            {mapView}
                                            {generateReport && <div style={{ display: "none" }} >
                                                {staticOutlinemapView}<br /> {reportButtonVisible && <img size="sm" id="btnDownload" onLoad={generateReportafterDelay()}></img>}
                                            </div>
                                            }
                                    </Col>
                                    </Row>
                                    
                                </Col>
                            </Row>
                        </Col>
                        <Col id="itemTypeListView" style={{ display: toggleSwitch == 'map' ? 'block' : 'none', height: "70vh", overflowY: "scroll", width: "25vw" }}>
                            <br />
                            {itemTypeListView}
                            <br />
                        </Col>
                        <Col id='nonMapView' style={{ width: "50vw", display: toggleSwitch == 'map' ? 'none' : 'block', marginTop: "-25px" }}>
                            <Row>
                                <Col sm="3"> {toggleSwitch == 'map & details' &&
                                    <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('details')}>Full Details&nbsp;&nbsp;
                                        <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                    </Button>
                                }
                                    {toggleSwitch == 'details' &&
                                        <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Details&nbsp;&nbsp;
                                            <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                        </Button>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {nonMapView}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                 </div>
            }

            <Modal size="lg" isOpen={itemPopup.showItemPopup} backdrop={false} className="outlineItemPopup">
                <Form>
                    <ModalHeader toggle={handleItemPopupClose} >Add/Edit Item</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                {itemPopup.markertype == "polygon" ?
                                    <FormGroup>
                                        <Label>Please give this outline a name</Label>
                                        <label id="outlineDescription" className="control-description">If your farm only has a single outline generally this can be as simple as "My Farm" or the farm name. If your farm has multiple outlines such as a separate runoff area, then name the outlines appropriately such as "Main Farm" and "Runoff" etc.</label>
                                        <Input type="text" name="txtShapeName" id="txtShapeName" value={itemName} onChange={handleNameChange} placeholder="Name" required />
                                    </FormGroup>
                                    :
                                    <FormGroup>
                                        <Label>Name</Label>
                                        <Input type="text" name="txtShapeName" id="txtShapeName" value={itemName} readOnly disabled />
                                    </FormGroup>
                                }
                            </Col>
                        </Row>
                        {itemPopup.markertype == "polygon" &&
                            <Row xs="2">
                                <Col>
                                    <FormGroup>
                                        <Label>Is this the whole Farm Outline ? </Label>
                                        {' '}
                                        <input className="isWholeFarmOutline form-check-input" id="isWholeFarmOutline" value={isWholeFarmOutline} checked={isWholeFarmOutline} type="checkbox" onChange={handleIsWholeFarmOutlineChange} />
                                       
                                    </FormGroup>
                                </Col>
                            </Row>           
                        }
                        {itemPopup.markertype == "polygon" ?
                            <Row xs="2">
                                <Col>
                                    <FormGroup>
                                        <Label>Boundary Perimeter (km) : </Label><Label id="lblOutlinePerimeter">{itemPopup.perimeter}</Label>
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label>Outline Size (ha) : </Label> <Label id="lblOutlinearea">{itemPopup.area}</Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            :
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label>GPS Location : </Label><Label id="lblOutlineloaction">{itemPopup.coordinates}</Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                        }
                    </ModalBody>
                    <ModalFooter>
                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                            <>
                        {itemPopup.id != 0 && itemPopup.markertype == "polygon" ?
                            <>
                                <Button onClick={handleItemDelete} color="danger" size="sm">
                                    Delete
                                </Button>{' '}
                            </>
                             : ''}
                        {/*<Button color="success" onClick={handleItemSubmit} size="sm">Save</Button>*/}
                        {savingItem ?
                            <>
                                <Button onClick={handleItemSubmit} color="success" disabled size="sm">
                                    <Row>
                                        <Col sm="6">
                                            <span>
                                                {' '}Saving
                                            </span>
                                        </Col>
                                        <Col sm="6">
                                            <Spinner size="sm">
                                                Saving...
                                            </Spinner>
                                        </Col>
                                    </Row></Button>{' '}
                            </>
                            :
                            <>
                                <Button onClick={handleItemSubmit} color="success" size="sm">
                                    Save
                                </Button>{' '}
                            </>
                            }
                            </>
                        }
                        <Button color="primary" onClick={handleItemPopupClose} size="sm">Cancel</Button>

                    </ModalFooter>
                </Form>
            </Modal>

            <Modal isOpen={itemDeletePopup.showItemdeletePopup}>
                <ModalHeader toggle={HandleItemDeletePopupClose} >Delete the item</ModalHeader>
                <ModalBody>
                    Do you want to delete the item ?
                </ModalBody>
                <ModalFooter>
                    {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                        <>
                    {savingItemDelete ?
                        <>
                            <Button onClick={deleteItem} color="primary" disabled >
                                <Row>
                                    <Col sm="6">
                                        <span>
                                            {' '}Saving
                                        </span>
                                    </Col>
                                    <Col sm="6">
                                        <Spinner size="sm">
                                            Saving...
                                        </Spinner>
                                    </Col>
                                </Row></Button>{' '}
                        </>
                        :
                        <>
                            <Button onClick={deleteItem} color="primary" >
                                Yes
                            </Button>{' '}
                        </>
                        }
                        </>
                    }
                    <Button color="danger" onClick={HandleItemDeletePopupClose}>No</Button>
                </ModalFooter>
            </Modal>

            <Modal size="lg" isOpen={itemBulkPopup.showBulkItemPopup} backdrop={false} className="outlineItemPopup">
                <Form>
                    <ModalHeader toggle={HandleBulkItemPopupClose} >Add/Edit Item</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Please give this outline a name</Label>
                                    <label id="outlineDescription" className="control-description">The same name will applied to all the items and you can update once it get saved.</label>
                                    <Input type="text" name="txtShapeName" id="txtShapeName" value={itemName} onChange={handleNameChange} placeholder="Name" required />
                                </FormGroup>
                            </Col>
                        </Row>

                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={handleBulkItemSubmit}>Save</Button>
                        <Button color="primary" onClick={HandleBulkItemPopupClose}>Cancel</Button>

                    </ModalFooter>
                </Form>
            </Modal>
        </div>
    );
}
export default Outline;